import React, { Component } from 'react';
import { Link } from 'react-router-dom';
//import './App.css';
import firebase from './../Firestore'

import config from 'react-global-configuration';

import Imagen from './Imagen'
import NavBar from './NavBar'

class CategoriaLista extends Component {
  constructor(props) {
    super(props);
    this.ref = firebase.firestore().collection('categoria').orderBy("orden");
    this.unsubscribe = null;

    this.state = {
      categorias: []
    };
  }

  onCollectionUpdate = (querySnapshot) => {
    const categorias = [];
    querySnapshot.forEach((doc) => {
      const { nombre, imagen, orden, seFracciona, diseno } = doc.data();
      categorias.push({
        key: doc.id,
        doc, // DocumentSnapshot
        nombre,
        imagen,
        orden,
        seFracciona,
        diseno
      });
    });
    this.setState({
      categorias
   });
  }



  async componentDidMount() {
    this.unsubscribe = await this.ref.onSnapshot(this.onCollectionUpdate);

  }

  render() {
    return (
      <div className="container">
        <NavBar history={this.props.history} />
        <div className="panel panel-default">
          <div className="panel-heading">
            <h3 className="panel-title">
              LISTA CATEGORIAS
            </h3>
          </div>
          <div>
            <small>Tocar el nombre de la categoría para editarla.</small>
          </div>
          <div className="panel-body">
            <table className="table table-stripe">
              <thead>
                <tr>
                  <th>Categorias</th>
                </tr>
              </thead>
              <tbody>
                {this.state.categorias.map((categoria, index, arr) =>

                  <tr key={categoria.key}>
                    <td>

                       {(categoria.imagen) &&
                           <Imagen imagen={categoria.imagen} nombre={categoria.nombre} />
                        }

                      <Link className="mr-2" to={`/admin/categoria/show/${categoria.key}`}><strong>{categoria.nombre}</strong></Link>
                      {(categoria.orden > 0 && typeof(categoria.orden) !== "undefined") &&
                        <span className="mr-2"><small>Orden: {categoria.orden}</small></span>
                       }
                      <span className="mr-2"><small>{categoria.seFracciona ? "Se fracciona" : "No se fracciona"}</small></span>

                      <span className="mr-2"><small>Diseño: {categoria.diseno}</small></span>


                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    );
  }
}

export default CategoriaLista;
